module.exports = __webpack_public_path__ + "weathericons-regular-webfont.f5b0d0d9cb02e5510031.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/thana/Documents/sdc-nida-front_2024/backoffice/node_modules/weather-icons/font/weathericons-regular-webfont.woff
// module id = ../../../../weather-icons/font/weathericons-regular-webfont.woff
// module chunks = styles